<template>
  <SectionWrapper title="내일매출 당겨받기" :loading="getOngoingLoansLoading">
    <template v-slot:title-action>
      <v-btn
        small
        depressed
        color="accent"
        :to="{ name: 'loan/pull-revenue' }"
        class="rounded-3 font-weight-bold mt-n1"
        :disabled="getOngoingLoansLoading"
      >
        한도 조회
      </v-btn>
    </template>

    <section class="accent-text-box">
      <p>상품 소개</p>
      <h3>
        최대 5일 매출까지 당겨받으시고<br />
        30일간 나눠서 정산하세요
      </h3>
    </section>
  </SectionWrapper>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    SectionWrapper: () => import('@/components/main/SectionWrapper.vue'),
  },
  computed: {
    ...mapGetters('loan', ['getOngoingLoansLoading']),
  },
}
</script>

<style lang="scss" scoped></style>
